import { useMemo } from 'react';

import { formatDate, getMonth, getYear, MonthValue, parseDate } from '../../../utils/date';
import { Cell } from '../Cell';
import { Controls } from '../Controls';

type Props = {
  displayYear: number;
  selectedMonth?: number;
  onPreviousYear: () => void;
  onNextYear: () => void;
  onHeaderClick: () => void;
  onSelectMonth: (_month: MonthValue) => void;
  maxDate?: number;
  minDate?: number;
};

export const MonthView = ({
  displayYear,
  selectedMonth,
  onNextYear,
  onPreviousYear,
  onHeaderClick,
  onSelectMonth,
  maxDate,
  minDate,
}: Props) => {
  const { maxYear, minYear, maxMonth, minMonth } = useMemo(() => {
    const maxYear = maxDate ? getYear(maxDate) : undefined;
    const minYear = minDate ? getYear(minDate) : undefined;
    const maxMonth = maxDate ? getMonth(maxDate) : undefined;
    const minMonth = minDate ? getMonth(minDate) : undefined;

    return { maxYear, minYear, maxMonth, minMonth };
  }, [maxDate, minDate]);

  return (
    <div className="inline-block">
      <Controls
        onHeaderClick={onHeaderClick}
        onPrevious={onPreviousYear}
        onNext={onNextYear}
        label={`${displayYear}`}
        isNextDisabled={maxYear != null && displayYear >= maxYear}
        isPreviousDisabled={minYear != null && displayYear <= minYear}
      />
      <div className="w-64 grid grid-cols-4">
        {Array.from({ length: 12 }).map((_, index) => (
          <Cell
            key={index}
            isSelected={selectedMonth === index}
            onClick={() => onSelectMonth(index as MonthValue)}
            isDisabled={
              (maxYear != null && displayYear > maxYear) ||
              (minYear != null && displayYear < minYear) ||
              (maxMonth != null && maxYear === displayYear && index > maxMonth) ||
              (minMonth != null && minYear === displayYear && index < minMonth)
            }
          >
            {formatDate(parseDate(`${displayYear}-${index + 1}-15`, 'YYYY-M-D'), 'MMM')}
          </Cell>
        ))}
      </div>
    </div>
  );
};
